import React, { useState } from 'react';
import axios from 'axios';

// "Have a promo code?" (GROWTH-001). The server decides whether the code is valid and how much it
// adds; onApplied({ code, credit }) runs after it has been added to the balance.
function PromoCodeForm({ onApplied, onError }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    setMessage('');
    try {
      const res = await axios.post('/.netlify/functions/employerCredits', { action: 'redeemPromo', code: code.trim() });
      setCode('');
      setOpen(false);
      onApplied(res.data.result);
    } catch (err) {
      const text = (err && err.response && err.response.data && err.response.data.error) || 'Unable to apply the code. Please try again.';
      setMessage(text);
      if (onError) onError(text);
    } finally {
      setBusy(false);
    }
  }

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="text-sm font-medium text-primary hover:underline">
        Have a promo code?
      </button>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-wrap items-start gap-2">
      <label htmlFor="promo-code-input" className="sr-only">
        Promo code
      </label>
      <input
        id="promo-code-input"
        type="text"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        maxLength={32}
        autoComplete="off"
        autoFocus
        placeholder="Promo code"
        className="w-40 uppercase rounded-md border-gray-300 text-sm shadow-sm focus:border-primary focus:ring-primary"
      />
      <button
        type="submit"
        disabled={busy || !code.trim()}
        className="cursor-pointer rounded-md bg-primary px-3 py-2 text-sm font-medium text-white hover:bg-red-800 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {busy ? 'Applying…' : 'Apply'}
      </button>
      <button type="button" onClick={() => { setOpen(false); setMessage(''); }} className="px-2 py-2 text-sm text-gray-500 hover:text-gray-700">
        Cancel
      </button>
      {message && <p className="w-full text-sm text-red-700">{message}</p>}
    </form>
  );
}

export default PromoCodeForm;
